import Axios from 'axios'
import configs from '@@ting/configs'

export const axiosInstance = Axios.create({
  baseURL: configs.app.api,
})

export const { CancelToken } = Axios
export type { AxiosResponse } from 'axios'
